import states from "./States";
export const DefaultSearchFieldsCargoTrailer = {
    categoryName: "Cargo Trailers",
    fields : [
        {
            hideField: false,
            label: "Newest listings",
            fieldType: "sortonly",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "1",
            sortable: true, // Some fields are only for sorting
            isBeingSorted: false, // If a sort isn't supplied, default to this one.
            sortDirection: "desc"
        },
        {
            hideField: false,
            label: "Year",
            fieldType: "multiselect",
            searchValue: "",
            selectedValue: "",
            selectedValues: [], // Will be populated
            filterId: "5",
            sortable: true,
            isBeingSorted: true, // If a sort isn't supplied, default to this one.
            isDefaultSort: true,
            sortDirection: "desc"
        },
        {
            hideField: false,
            label: "Distance from your zipcode",
            fieldType: "sortonly",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "43",
            sortable: true,
            sortDirection: "asc",
        },
        {
            hideField: false,
            label: "Manufacturer",
            fieldType: "multiselect",
            searchValues: [], // Some fields, like manufacturer and horses, will be populated when the app initializes
            selectedValue: "", // Used by textboxes, checkboxes, select
            selectedValues: [], // Used by multiselect
            filterId: "7",
            sortable: true,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Type",
            fieldType: "multiselect",
            searchValues: [
                { label: "Flatbed", value: "Flatbed" },
                { label: "Open Utility", value: "Open Utility" },
                { label: "Closed Utility", value: "Closed Utility" },
                { label: "Cattle Hauler", value: "Cattle Hauler" },
                { label: "Deckover", value: "Deckover" },
                { label: "Equipment", value: "Equipment" },
                { label: "Feeder", value: "Feeder" },
                { label: "Livestock", value: "Livestock" },
                { label: "RV Trailer", value: "RV Trailer" },
                { label: "Motorcycle/ATV", value: "Motorcycle/ATV" },
                { label: "Boat Trailer", value: "Boat Trailer" },
                { label: "Car Hauler", value: "Car Hauler" },
                { label: "Dump", value: "Dump" },
                { label: "Race Car", value: "Race Car" },
                { label: "Snowmobile", value: "Snowmobile" },
                { label: "Toy Hauler", value: "Toy Hauler" },
                { label: "Drop Deck", value: "Drop Deck" },
            ], // Will be pruned
            selectedValue: "",
            selectedValues: [],
            filterId: "4",
            sortable: true,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "New or Used",
            fieldType: "select",
            searchValues:
                [
                    // select options should have an "Any" field, but omit this option from multiselect
                    {
                        label: "Any",
                        value: ""
                    },
                    {
                        label: "New",
                        value: "Y"
                    },
                    {
                        label: "Used",
                        value: "N"
                    }
                ],
            selectedValue: "",
            selectedValues: [],
            filterId: "37",
        },
        {
            hideField: false,
            label: "Pull",
            fieldType: "select",
            searchValues:
                [
                    // select options should have an "Any" field, but omit this option from multiselect
                    {
                        label: "Any",
                        value: ""
                    },
                    {
                        label: "Bumper pull",
                        value: "B"
                    },
                    {
                        label: "Gooseneck",
                        value: "G"
                    }
                ],
            selectedValue: "",
            selectedValues: [],
            filterId: "8",
            sortable: true,
        },
        {
            hideField: false,
            label: "Price",
            fieldType: "multiselect",
            searchValues:
                [
                    {
                        label: "Under $2,500",
                        value: "0-2500"
                    },
                    {
                        label: "$2,500 to $5,000",
                        value: "2500-5000"
                    },
                    {
                        label: "$5,000 to $10,000",
                        value: "5000-10000"
                    },
                    {
                        label: "$10,000 to $20,000",
                        value: "10000-20000"
                    },
                    {
                        label: "$20,000 +",
                        value: "20000-999999"
                    }
                ],
            selectedValue: "",
            selectedValues: [],
            filterId: "19",
            sortable: true,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Your zipcode",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "zip", // The zip code distance is a unique field. It has a searchkey of 'zip', but a sort field of 43
            setFilterIdWhenChanged: "43" // When this field is entered, default the sort field. A user can still change it.
        },
        {
            hideField: false,
            label: "Stock #",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "23",
        },
        {
            hideField: false,
            label: "City",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "12",
        },
        {
            hideField: false,
            label: "State",
            fieldType: "multiselect",
            searchValues: states,
            selectedValue: "",
            selectedValues: [],
            filterId: "13",
        },
        {
            hideField: true,
            label: "Custom #1",
            fieldType: "checkbox",
            searchValue: "1",
            selectedValue: "",
            selectedValues: [],
            filterId: "40",
        },
        {
            hideField: true,
            label: "Custom #2",
            fieldType: "checkbox",
            searchValue: "1",
            selectedValue: "",
            selectedValues: [],
            filterId: "41",
        },
    ]

}
